const yupValidator = (params = {}) => () => {
  return {
    validate({ value }, fn) {
      try {
        fn.validateSync(value);
        return;
      } catch (_e) {
        const e = _e;
        if (params.transformErrors) {
          return params.transformErrors(e.errors);
        }
        return e.errors.join(", ");
      }
    },
    async validateAsync({ value }, fn) {
      try {
        await fn.validate(value);
        return;
      } catch (_e) {
        const e = _e;
        if (params.transformErrors) {
          return params.transformErrors(e.errors);
        }
        return e.errors.join(", ");
      }
    }
  };
};
export {
  yupValidator
};
//# sourceMappingURL=validator.js.map
